import { render, staticRenderFns } from "./ThirdPersonAssurancesWidget.vue?vue&type=template&id=591bcf2c&scoped=true"
import script from "./ThirdPersonAssurancesWidget.vue?vue&type=script&lang=js"
export * from "./ThirdPersonAssurancesWidget.vue?vue&type=script&lang=js"
import style0 from "./ThirdPersonAssurancesWidget.vue?vue&type=style&index=0&id=591bcf2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591bcf2c",
  null
  
)

export default component.exports